import { useParams, useNavigate } from 'react-router-dom';
import MainLayout from '@/layouts/MainLayout';
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useGetCampaignPitches, useGetCampaigns } from '../../react-query/outreach-queries';
import { KanbanBoard } from '../../components/outreach/KanbanBoard';

export default function CampaignBoardPage() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    
    // We fetch all campaigns to find the name of current one (could be optimized)
    const { data: campaigns } = useGetCampaigns();
    const { data: pitches, isLoading } = useGetCampaignPitches(id || '');

    const campaign = campaigns?.find(c => c.id === id);

    if (!id) return <div>Invalid Campaign ID</div>;

    return (
        <MainLayout>
            <div className="flex bg-slate-50 h-[calc(100vh-64px)] overflow-hidden">
                <main className="flex-1 flex flex-col p-4 md:p-6 w-full max-w-[1920px] mx-auto">
                    <div className="w-full flex flex-col h-full">
                        <div className="mb-4 flex items-center justify-between shrink-0">
                            <div>
                                <Button 
                                    variant="ghost" 
                                    size="sm" 
                                    onClick={() => navigate('/dashboard/outreach')} 
                                    className="mb-1 pl-0 hover:pl-0 hover:bg-transparent hover:text-primary"
                                >
                                    <ArrowLeft className="size-4 mr-2" />
                                    Back to Campaigns
                                </Button>
                                <h1 className="text-2xl font-bold tracking-tight text-gray-900">
                                    {campaign ? campaign.name : 'Campaign Board'}
                                </h1>
                            </div>
                        </div>
                        
                        <div className="flex-grow overflow-hidden bg-slate-100 rounded-lg p-2 border border-slate-200">
                            {isLoading ? (
                                <div className="text-muted-foreground p-4">Loading Pitches...</div>
                            ) : (
                                <KanbanBoard pitches={pitches || []} campaignId={id} />
                            )}
                        </div>
                    </div>
                </main>
            </div>
        </MainLayout>
    );
}
